export default (axios) => ({
  getCountries(payload) {
    return axios.get('v1/countries', { params: payload })
  },
  getStates(payload) {
    return axios.get('v1/states', { params: payload })
    // return fetch('/states.json').then((res) => res.json())
  },
  getCities(payload) {
    return axios.get('v1/cities', { params: payload })
    // return axios.get('http://localhost:5173/test.json', { params: payload })
    // return fetch('/cities.json').then((res) => res.json())
  },
  zones(payload) {
    return axios.get('v1/zones', { params: payload })
  },
  zonesCities(payload) {
    return axios.get('v1/zones/cities', { params: payload })
  },
  zonesManagments(payload) {
    return axios.get('v1/zones/managments', { params: payload })
  }
})
